import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import LocationSelect from 'App/Vehicles/shared/LocationSelect';
import React from 'react';

import { InputField } from 'Elements/Form';

import UserRole from './UserRole';

export default function UserBasicInfo() {
  return (
    <Card elevation={1}>
      <CardHeader title="Käyttäjätiedot" />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <InputField
              fullWidth
              name="user.first_name"
              variant="outlined"
              placeholder="Syötä etunimi"
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>

          <Grid item xs={6}>
            <InputField
              fullWidth
              name="user.last_name"
              variant="outlined"
              placeholder="Syötä sukunimi"
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>

          <Grid item xs={12}>
            <LocationSelect name="user.location_id" />
          </Grid>

          <Grid item xs={12}>
            <InputField
              fullWidth
              name="user.email"
              variant="outlined"
              placeholder="Syötä sähköpostiosoite"
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>

          <UserRole />
        </Grid>
      </CardContent>
    </Card>
  );
}
